module.exports = __webpack_public_path__ + "img/customer-service-de.bfa2b5fc.svg";